export default "__VITE_ASSET__XbZ3rRYE__"